// Traducciones comunes en español
const common = {
  chapters: "CAPÍTULOS",
  chapter: "Capítulo",
  form: "¡TU OPINIÓN IMPORTA!",
  selectChapter: "Selecciona un Capítulo",
  backToMenu: "Regresar al inicio",
  backtoChapters: "Regresar al listado de capitulos",
  chapterOptions: "Opciones del capítulo",
  comic: "Cómic",
  articles: "Fichas",
  extras: "Extras",
  pause: "Pausado",
  suscribe: "¡Suscribete para ser el primero en verlo!",
  privacyPolicy: "Política de privacidad",
  notFoundTitle: "404 - Página no encontrada",
  notFoundMessage: "Lo sentimos, la página que buscas no existe.",
  backToHome: "Volver al inicio",
  callToAction: {
    title: "¿Qué te ha parecido este capítulo?",
    subtitle: "Tu opinión nos ayuda a crear mejores historias. Comparte tu experiencia con nosotros.",
    primaryButton: "¡Valorar Capítulo!",
    primaryButtonHover: "¡Danos tu opinión!",
    footer: "Cada opinión cuenta para mejorar la aventura de Zaquiel",
    endIndicator: "Fin del capítulo"
  }
}; 

export default common; 